import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询坐席在线时间
export function querysiponline (params, data) {
  params.token = getToken()
  return request({
    url: '/querysiponline',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/seatonline.js